import { useMemo, useSyncExternalStore } from 'react'
import { MOBILE_BREAKPOINT, TABLET_BREAKPOINT, DESKTOP_BREAKPOINT } from '@/utils/constants'

const subscribe = (notify: () => void) => {
	window.addEventListener('resize', notify)
	return () => window.removeEventListener('resize', notify)
}
const getSnapshot = () => `${window.innerWidth}:${window.innerHeight}`

function useWindowSize(initialWidth = 0, initialHeight = 0) {
	// A stable server snapshot avoids hydration mismatches. React reads the
	// browser dimensions immediately after hydration and on viewport changes.
	const dimensions = useSyncExternalStore(subscribe, getSnapshot, () => `${initialWidth}:${initialHeight}`)
	return useMemo(() => {
		const [width, height] = dimensions.split(':').map(Number)
		return { width, height, isMobile: width < MOBILE_BREAKPOINT,
			isDesktop: width >= TABLET_BREAKPOINT, isLargeDesktop: width >= DESKTOP_BREAKPOINT }
	}, [dimensions])
}

export default useWindowSize
